import { Space, Table, message } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DeleteButton from "../UI/DeleteButton/deletebutton";
import PrintButton from "../UI/PrintButton/printbutton";
import ViewButton from "../UI/ViewButton/viewbutton";
import DeleteModal from "../UI/ModalComponent/DeleteModal/deletemodal";
import { useMutation } from "react-query";
import { deleteSale, deleteSaleReturn } from "../../api/sales";
import { deletePayments } from "../../api/receipts";
import { useNavigate } from "react-router";
import { format } from "date-fns";
import { CustomerBalanceListInterface } from "./types";

export const CustomerBalanceList = ({
  customerBalance,
  customerBalanceLoading,
  page,
  setPage,
  getCustomerBalanceMutation,
  setCustomersBalance,
  tablekey,
}: CustomerBalanceListInterface) => {

  const [t] = useTranslation("common");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<any>(null);
  const [typeToDelete, setTypeToDelete] = useState<any>();
  const [prevPage, setPrevPage] = useState<number>(0);
  const [maxPage, setMaxPage] = useState<number>(0);

  const { mutateAsync: deleteSaleMutation } = useMutation(
    "deleteSale",
    () => deleteSale(idToDelete),
    {
      onSuccess: () => {
        getCustomerBalanceMutation();
        message.success("Deleted successfully!");
      },
    }
  );

  const { mutateAsync: deleteSaleReturnMutation } = useMutation(
    "deleteSaleReturn",
    () => deleteSaleReturn(idToDelete),
    {
      onSuccess: () => {
        getCustomerBalanceMutation();
        message.success("Deleted successfully!");
      },
    }
  );

  const { mutateAsync: deleteReceiptMutation } = useMutation(
    "deleteReceipt",
    () => deletePayments({ id: idToDelete }),
    {
      onSuccess: () => {
        getCustomerBalanceMutation();
        message.success("Deleted successfully!");
      },
    }
  );

  const handleDelete = (id: number | null, type: string): void => {
    setOpen(true);
    setIdToDelete(id);
    setTypeToDelete(type);
  };

  const handleView = (id: number | null, type: string): void => {
    type === "Sale"
      ? navigate(`/sales`, {
        state: { id: id },
      })
      : type === "Sales Return"
        ? console.log("sales Return ")
        : navigate(`/customerreceipts`, {
          state: { id: id },
        });
  };

  const handleOk = () => {
    typeToDelete === "Sale"
      ? deleteSaleMutation()
      : typeToDelete === "Sale Return"
        ? deleteSaleReturnMutation()
        : deleteReceiptMutation();
    setOpen(false);
  };

  useEffect(() => {
    if (page > 1) {
      page > prevPage &&
        maxPage < page &&
        getCustomerBalanceMutation().then((res: any) => {
          if (page > maxPage) setMaxPage(page);

          setCustomersBalance(res.data.data);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const columns: {}[] = [
    {
      title: `${t("transaction-type")}`,
      dataIndex: "transaction",
      key: "transaction",
      width: "10rem",
      className: "table-header",
      render: (record: any) => {
        return record ? record.type : null;
      },
    },
    {
      title: `${t("date")}`,
      dataIndex: "date",
      key: "date",
      width: "10rem",
      render: (date: any) => {
        return format(new Date(date), "MM/dd/yyyy HH:mm");
      },
    },
    {
      title: `${t("payment-mode")}`,
      dataIndex: "paymentMode",
      key: "paymentMode",
      width: "15rem",
      render: (record: any) => {
        return record ? record.mode : null;
      },
    },
    {
      title: `${t("amount")}`,
      dataIndex: "amountText",
      key: "amountText",
      width: "7rem",
    },

    {
      title: `${t("running-balance")}`,
      dataIndex: "runningBalanceText",
      key: "runningBalanceText",
      width: "8rem",
    },
    {
      title: `${t("notes")}`,
      dataIndex: "notes",
      key: "notes",
    },

    {
      title: `${t("action")}`,
      key: "action",
      width: "7rem",
      align: "center",
      render: (record: any) => (
        <Space>
          <PrintButton onClick={() => console.log("hh")} />

          <ViewButton
            onClick={() =>
              handleView(record?.transaction?.id, record?.transaction?.type)
            }
          />
          <DeleteButton
            onClick={() =>
              handleDelete(record?.transaction?.id, record?.transaction?.type)
            }
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={typeToDelete}
        onOk={handleOk}
      />
      <Table
        key={tablekey}
        loading={customerBalanceLoading}
        scroll={{ x: 1000 }}
        columns={columns}
        dataSource={customerBalance}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        pagination={{ pageSize: 10 }}
        onChange={(selectedPage) => {
          setPrevPage(page);
          setPage(selectedPage?.current ?? 1);
        }}
      />
    </>
  );
};
